import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import Workflow from './Workflow'
import ErrorBoundary from '../ErrorBoundary'

export default function WorkflowTemplateEditor (props) {
  return Workflow(
    props.generalUsers,
    props.managers,
    null,
    'ルート設定者',
    false,
    true
  )
}

WorkflowTemplateEditor.propTypes = {
  generalUsers: PropTypes.arrayOf(PropTypes.object),
  managers: PropTypes.arrayOf(PropTypes.object)
}

$('#workflow-template-editor').each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(
    <ErrorBoundary>
      <WorkflowTemplateEditor {...props}/>
    </ErrorBoundary>,
    el
  )

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
